import type { PluginRouteFactory } from "@d12labs/plugins/types";
import { createRoute } from "@tanstack/react-router";
import { lazy } from "react";

const NotesPage = lazy(() => import("./pages/notes.page").then((m) => ({ default: m.NotesPage })));

export const createPluginRoutes: PluginRouteFactory = (parentRoute) =>
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/notes",
		component: NotesPage,
	});
